import {createSlice} from "@reduxjs/toolkit";
import {fillInput} from "../functions";

const initialSendData = {
    initialData: {
        fieldList: [
            {label: "نام و نام  خانوادگی", value: "nameAndFamilyName"},
            {label: "تاریخ", value: "date"},
            {label: "کد ملی", value: "socialSecurityCode"},
        ],
        timeOptions:[
            {value:"all" , label:"دائمی"},
            {value:"year" , label:"سالیانه"},
            {value:"month" , label:"ماهیانه"},
            {value:"weak" , label:"هفتگی"},
            {value:"day" , label:"روزانه"},
            {value:"range" , label:"در بازه"}
        ],
        ifData:[
            {
                label: "کد موجودی",
                value: "KODEKA",
                data: [],
                type: "number"
            },
            {
                label: "کد کالا",
                value: "CKALA",
                data: [],
                type: "number"
            },
            {
                label: "نام کالا",
                value: "NKALA",
                data: [],
                type: "string"
            },
            {
                label: "کد انبار",
                value: "IDANBAR",
                data: [],
                type: "number"
            },
            {
                label: "عنوان انبار",
                value: "ONVANBAR",
                data: [],
                type: "string"
            },
            {
                label: "کد گروه کالا",
                value: "CODEGRKALA",
                data: [],
                type: "number"
            },
            {
                label: "نام گروه کالا",
                value: "NGRKALA",
                data: [],
                type: "string"
            },
            {
                label: "وزن / تعداد ورودی",
                value: "TEIN",
                data: [],
                type: "number"
            },
            {
                label: "وزن / تعداد خروجی",
                value: "TEOUT",
                data: [],
                type: "number"
            },
            {
                label: "وزن / تعداد موجود",
                value: "TEMOGOD",
                data: [],
                type: "number"
            },
            {
                label: "قیمت فروش",
                value: "GHFOROSH",
                data: [],
                type: "number"
            },
            {
                label: "ارزش کالا",
                value: "ARZESHKALA",
                data: [],
                type: "number"
            },
            {
                label: "جمع ارزش کالا",
                value: "JAMARZKALA",
                data: [],
                type: "number"
            },
            {
                label: "ردیف",
                value: "RADIF",
                data: [],
                type: "number"
            },
            {
                label: "لاین",
                value: "LINE",
                data: [],
                type: "string"
            }
        ]
    },
    title: "",
    boxAddText: "",
    addFieldObject: {},
    mainText: "",
    timePeriod: "daily", // always , annual , month , week , daily , inDate,
    startDate: "",
    endDate: "",
    condition: [{
        name: "بدهکارای بالایی 500 تومن",
        tableData: [
            {
                field: "مقدار ",
                textField: "مقدار ",
                operator: "مقدار ",
                textOperator: "مقدار ",
                value: "مقدار ",
                textValue: "مقدار ",
                andOr: "مقدار ",
                textAndOr: "مقدار ",
            },
            {
                field: "مقدار1 ",
                textField: "مقدار1 ",
                operator: "مقد1ار ",
                textOperator: "مقد1ار ",
                value: "م1قدار ",
                textValue: "مق1دار ",
                andOr: "م1قدار ",
                textAndOr: "مقد1ار ",
            }
        ]
    }],
}

const smsReducers = {
    fillInput,
    fillInitialData: (state, action) => {
        state.initialData = action.payload.initialData
    },
    timePeriodChanger:(state, action) => {
        state.timePeriod = action.payload.timePeriod
    }
}


export const smsSlice = createSlice({
    name: 'smsSlice',
    initialState: initialSendData,
    reducers: smsReducers
});


const initialData = {}
const initialDataReducers = {}
const sendSMSInitialData = createSlice({
    name: 'initialDataReducers',
    initialState: initialData,
    reducers: initialDataReducers
});

export const smsSliceActions = smsSlice.actions
export default smsSlice.reducer
